import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AtaraxiaAnimateModule } from '@epicuro-next/ataraxia/animate';
import { AvatarModule } from '@epicuro-next/ataraxia/avatar';
import { CommercialListRibbonModule } from '@epicuro-next/ataraxia/commercial-list-ribbon';
import { DateModule } from '@epicuro-next/ataraxia/date';
import { DomSanitizerModule } from '@epicuro-next/ataraxia/dom-sanitizer';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { RemoveMarkdownPipe } from '@epicuro-next/ataraxia/markdown';
import { MediaAspectRatioModule } from '@epicuro-next/ataraxia/media-aspect-ratio';
import { ModalModule } from '@epicuro-next/ataraxia/modal';
import { PopoverModule } from '@epicuro-next/ataraxia/popover';
import { SnackBarModule } from '@epicuro-next/ataraxia/snack-bar';
import { SwitchesModule } from '@epicuro-next/ataraxia/switches';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { DataEngagementApiModule } from '@epicuro-next/data/engagement/engagement-api';
import { EngagementCommonModule } from '@epicuro-next/features/engagement/engagement-common';
import { HotListIndicatorModule } from '@epicuro-next/features/engagement/hot-list-indicator';
import { ShareableListModule } from '@epicuro-next/features/lists/shareable-list';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { PlatformTargetModule } from '@epicuro-next/platform/target';
import { AnalyticsEntitiesModule } from '@epicuro-next/state/analytics-entities';
import { ProductListStoreModule } from '@epicuro-next/state/product-list-state';
import { UserStateModule } from '@epicuro-next/state/user-state';
import { MarkdownModule } from 'ngx-markdown';
import { SortablejsModule } from 'nxt-sortablejs';

import { FeedArticleOverlayComponent } from './components/feed-article-overlay/feed-article-overlay.component';
import { FluidDragableListContentComponent } from './components/fluid-dragable-list-content/fluid-dragable-list-content.component';
import { ListCategoryHeaderComponent } from './components/list-category-header/list-category-header.component';
import { ListHeaderTextComponent } from './components/list-header-text/list-header-text.component';
import { ListHeaderComponent } from './components/list-header/list-header.component';
import { ListUserComponent } from './components/list-user/list-user.component';

export const publicComponents = [
  ListHeaderComponent,
  ListCategoryHeaderComponent,
  FeedArticleOverlayComponent,
  FluidDragableListContentComponent,
  ListUserComponent,
  ListHeaderTextComponent,
];

@NgModule({
  declarations: [...publicComponents],
  providers: [CurrencyPipe, DatePipe],
  imports: [
    PopoverModule,
    ProductListStoreModule,
    AvatarModule,
    ClipboardModule,
    CommonModule,
    ConfigurationModule,
    DataEngagementApiModule,
    IconsModule,
    PlatformTargetModule,
    ReactiveFormsModule,
    RouterModule,
    SwitchesModule,
    TooltipDirective,
    SortablejsModule,
    MediaAspectRatioModule,
    EngagementCommonModule,
    UserStateModule,
    PopoverModule,
    ModalModule,
    DateModule,
    SnackBarModule,
    AtaraxiaAnimateModule,
    AnalyticsEntitiesModule,
    HotListIndicatorModule,
    ShareableListModule,
    MarkdownModule,
    DomSanitizerModule,
    CommercialListRibbonModule,
    RemoveMarkdownPipe,
  ],
  exports: [publicComponents],
})
export class ListsModule {}
